<script>
    export default {
        methods: {
            /**
             * Use js-localization laravel package to translate text
             *
             * @param path
             * @param items
             * @returns Lang translated text
             */
            translate: function(path, items) {
                return Lang.get(path, items);
            },
            /**
             * Use js-localization laravel package to translate text
             *
             * @param path
             * @param {Integer} count           Subject count for pluralization.
             * @param {Object} [replacements]   Associative array: { variableName: "replacement", ... }
             * @returns Lang translated text
             */
            choice: function(path, add_prefix, count, replacements) {
                add_prefix = add_prefix || false;
                return Lang.choice((add_prefix == false ? 'frontend.js.' : '') + path, count, replacements);
            },
            /**
             * Changes the url to a certain width and height (using croppa)
             *
             * @author Rick van der Burg <rick@click.nl>
             * @param url
             * @param width
             * @param height
             * @return string with width and height
             */
            changeImageSize: function(url, width, height) {
                // set defaults
                width = width || '_';
                height = height || '_';

                // split url
                var splitted_url = url.split('.');

                // return croppa url
                return splitted_url[0] + '-'+width + 'x' + height + '.' + splitted_url[1];
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/frontend/vue/mixins/mixin.vue